const OdooSalesOrderView = ({ odooUrlInc, order, warehouse }) => {
  return (
    <div className="card">
      <h5 className="mb-2">{order.orderNumber}</h5>

      {order.odooSaleOrder && (
        <div className="mb-2 text-red-600 font-semibold">
          <p>
            This order has been synced to Odoo as{" "}
            <a
              className="text-purple-600"
              href={`${odooUrlInc}/odoo/sales/${order.odooSaleOrder.id}`}
              target="_blank"
            >
              {order.odooSaleOrder.name}
            </a>
          </p>
          <p>
            WIS will not sync this order again. If you want to sync it again,
            please delete the order in Odoo first.
          </p>
        </div>
      )}

      <div className="-mx-2">
        <table className="td-align-baseline">
          <tbody>
            <tr>
              <td>
                <label>Customer:</label>
              </td>
              <td className="w-full">{order.odooCustomer.name}</td>
            </tr>
            <tr>
              <td>
                <label>Delivery Address:</label>
              </td>
              <td className="w-full">
                {order.odooDeliveryAddress.contact_address_inline}
              </td>
            </tr>
            <tr>
              <td>
                <label>Warehouse:</label>
              </td>
              <td className="w-full">{warehouse}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="-mx-2 mt-4">
        <table className="with-line">
          <thead>
            <tr>
              <th>Item</th>
              <th className="text-right">Unit Price</th>
              <th className="text-right">Quantity</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {order.lines.map((line, lineIndex) => (
              <tr key={lineIndex}>
                <td>{line.buyerSku}</td>
                <td className="text-right">{line.unitPrice}</td>
                <td className="text-right">{line.quantity}</td>
                <td className="text-right">{line.lineTotal}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="font-semibold">
              <td>Total</td>
              <td></td>
              <td></td>
              <td className="text-right">{order.total.toFixed(2)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="mt-8 opacity-70">
        <p className="font-semibold">Note ⚠️</p>
        <p>Same products will be merged into one line.</p>
        <p>
          Commissions will be auto set to the Customer Sale Representative Info
          with 100% by default.
        </p>
        <p>
          Sales Price will be auto set to the customer's pricelist from odoo.
        </p>
        <p>You can change the order info in Odoo after syncing.</p>
      </div>
    </div>
  );
};

export default OdooSalesOrderView;
